export default [
    "jpg", "jpeg", "png", "gif"];